import { getToken, getIdToken, removeToken, signout } from '@/lib/oidc-client';
import { authDomain, domainKey } from './constants';
import { decodeToken, iframeProvider, updateInvalidToken } from './jwt-helpers';

export const signoutFx = authDomain.createEffect({
  name: `${domainKey}/effects/signoutFx`,
  handler: async () => {
    try {
      const idToken = await getIdToken();
      const accessToken = await getToken();
      await removeToken();
      await signout(idToken ?? accessToken);
    } catch (error) {
      return error;
    }
  },
  sid: `${domainKey}/effects/signoutFx`
});

export const updateExpiredTokenFx = authDomain.createEffect({
  name: `${domainKey}/effects/updateExpiredTokenFx`,
  handler: (token: string) => {
    const decoded = decodeToken<Record<string, unknown>>(token);
    const uniqueName = (decoded.unique_name as string) || '';
    iframeProvider(uniqueName);
    return Promise.resolve();
  },
  sid: `${domainKey}/effects/updateExpiredTokenFx`
});

export const updateInvalidTokenFx = authDomain.createEffect({
  name: `${domainKey}/effects/updateInvalidTokenFx`,
  handler: updateInvalidToken,
  sid: `${domainKey}/effects/updateInvalidTokenFx`
});

export const removeTokenFx = authDomain.createEffect({
  name: `${domainKey}/effects/removeTokenFx`,
  handler: async () => {
    removeToken();
  },
  sid: `${domainKey}/effects/removeTokenFx`
});
